<template>
    <div class="quickpay-preferences-loader">
        <CompassSkeleton class="quickpay-preferences-loader__title" :size="CompassEnums.SkeletonSize.LARGE" />
        <div class="quickpay-preferences-loader__group">
            <div
                v-for="index in 2"
                :key="`group1-${index}`"
                class="quickpay-preferences-loader__row"
            >
                <CompassSkeleton class="quickpay-preferences-loader__checkbox-icon" />
                <CompassSkeleton class="quickpay-preferences-loader__line" />
            </div>
        </div>
        <div class="quickpay-preferences-loader__group">
            <div
                v-for="index in 2"
                :key="`group2-${index}`"
                class="quickpay-preferences-loader__row"
            >
                <CompassSkeleton class="quickpay-preferences-loader__checkbox-icon" />
                <CompassSkeleton class="quickpay-preferences-loader__line" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.quickpay-preferences-loader {
    &__title {
        width: 260px;
        margin-bottom: var(--spacing-3);
    }

    &__group {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-2);
        margin-bottom: var(--spacing-6);

        &:last-child {
            margin-bottom: var(--spacing-1);
        }
    }

    &__row {
        display: flex;
        align-items: center;
        gap: var(--spacing-1);
    }

    &__checkbox-icon {
        width: 14px;
        height: 14px;
        flex-shrink: 0;
    }

    &__line {
        flex: 1;
    }
}
</style>
